import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

const Element = {
    install(Vue) {
        Vue.use(ElementUI)
    }
}

export default Element
